import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { ROUTE_CONSTANTS } from './core/constants/route.constant';
import { ForbiddenComponent } from './core/components/forbidden/forbidden.component';
import { AuthGuard } from './core/guards/auth.guard';
import { RolesGuard } from './core/guards/roles.guard';
import { PaywallGuard } from './core/guards/paywall.guard';
import { UserRoles } from './core/enums/user-roles.enum';

const routes: Routes = [
    {
        path: ROUTE_CONSTANTS.HOME,
        canActivateChild: [AuthGuard],
        loadChildren: () => import('./modules/training-search/training.module').then((m) => m.TrainingModule),
    },
    {
        path: ROUTE_CONSTANTS.LEGAL.ROOT,
        loadChildren: () => import('./modules/legal/legal.module').then((m) => m.LegalModule),
    },
    {
        path: ROUTE_CONSTANTS.SESSION,
        canActivateChild: [AuthGuard],
        loadChildren: () => import('./modules/session-viewer/session.module').then((m) => m.SessionModule),
    },
    {
        path: ROUTE_CONSTANTS.SESSIONS,
        canActivateChild: [AuthGuard],
        loadChildren: () => import('./modules/session-history/session-history.module').then((m) => m.SessionHistoryModule),
    },
    {
        path: ROUTE_CONSTANTS.CALENDAR,
        canActivateChild: [AuthGuard],
        loadChildren: () => import('./modules/calendar/calendar.module').then((m) => m.CalendarModule),
    },
    {
        path: ROUTE_CONSTANTS.SQUAD,
        canActivateChild: [AuthGuard],
        loadChildren: () => import('./modules/squad/squad.module').then((m) => m.SquadModule),
    },
    {
        path: ROUTE_CONSTANTS.UPGRADE,
        canActivate: [AuthGuard, PaywallGuard],
        loadChildren: () => import('./modules/paywall/paywall.module').then((m) => m.PaywallModule),
    },
    {
        // Shared plans, weeks and periods: open without signing in; a plan is complete when signed in.
        path: ROUTE_CONSTANTS.SHARED,
        loadChildren: () => import('./modules/shared-link/shared-link.module').then((m) => m.SharedLinkModule),
    },
    {
        path: ROUTE_CONSTANTS.AUTH.ROOT,
        loadChildren: () => import('./modules/auth/auth.module').then((m) => m.AuthModule),
    },
    {
        path: ROUTE_CONSTANTS.USER.ROOT,
        canActivateChild: [AuthGuard],
        loadChildren: () => import('./modules/user/user.module').then((m) => m.UserModule),
    },
    {
        path: ROUTE_CONSTANTS.ADMIN.ROOT,
        canActivate: [AuthGuard, RolesGuard],
        data: {
            roles: [UserRoles.Admin, UserRoles.Owner],
        },
        loadChildren: () => import('./modules/admin/admin.module').then((m) => m.AdminModule),
    },
    {
        path: ROUTE_CONSTANTS.FORBIDDEN,
        canActivateChild: [AuthGuard],
        component: ForbiddenComponent,
    },
    { path: '**', redirectTo: '' },
];

@NgModule({
    imports: [RouterModule.forRoot(routes)],
    exports: [RouterModule],
})
export class AppRoutingModule {}
